import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>ATAL INNOVATION KITS</h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                 Aligned with the Atal Innovation Mission (AIM) and Atal Tinkering Lab (ATL) initiatives, we design and supply hands-on STEM education kits that promote creativity, experimentation, and problem-solving. These kits are built around themes like robotics, programming, IoT, and electronics, helping students explore and innovate.{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       


        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
